<template>
  <div class="row-actions">
    <v-btn icon small title="Editar" @click="$emit('editar')"><v-icon small color="#4f46e5">mdi-pencil-outline</v-icon></v-btn>
    <v-btn icon small title="Excluir" @click="$emit('excluir')"><v-icon small color="#d84a59">mdi-delete-outline</v-icon></v-btn>
  </div>
</template>

<script>
export default { name: "OrcamentoAcoesRegistro" };
</script>

<style scoped>.row-actions{display:flex;justify-content:flex-end}</style>
